"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgFilterClose = props => (0, jsx_runtime_1.jsxs)("svg", {
  "data-name": "filter close",
  xmlns: "http://www.w3.org/2000/svg",
  width: 8.001,
  height: 8.001,
  ...props,
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Rectangle 284",
    fill: "#c76f00",
    d: "M7.112 0l.889.889L.889 8l-.888-.889z"
  }), (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Rectangle 285",
    fill: "#c76f00",
    d: "M8 7.112l-.889.889L0 .889.889.001z"
  })]
});
exports.default = SvgFilterClose;